import React from 'react';
import styled from '@emotion/styled';
import { Badge, Table } from 'antd';
import { useTranslation } from 'react-i18next';
import { USER_PROFILE } from '../../../constants/define/translation';
import { CommonColumn } from '../shared-column';
import { ActionsColumn } from './columns';

export const OnCourseTable = (prop: any) => {
  const { userProfile } = prop;
  const { onCourse, golferProfile } = userProfile;
  const { t } = useTranslation(USER_PROFILE);
  const { Column } = Table;

  const handleRound = (datas: any) => {
    if (!datas || !datas.length) {
      return null;
    }
    return (
      <div>
        {datas.map((item: any) => (
          <div>
            {item?.roundMode}: {item?.totals}
          </div>
        ))}
      </div>
    );
  };

  const records: any = [
    {
      description: 'Active',
      value: (
        <Badge status={onCourse?.deleteData ? 'error' : 'success'} text={onCourse?.deleteData ? 'false' : 'true'} />
      ),
    },
    {
      description: 'Strokes Gained Baseline',
      value: golferProfile?.strokesGainedBaseline,
    },
    {
      description: 'Rounds Played',
      value: handleRound(onCourse?.roundsPlayed),
    },
  ];
  const loading = false;

  return (
    <>
      <StyledTable dataSource={records} loading={loading} rowKey="id" pagination={false}>
        <Column
          title={t('table.title.description')}
          width={200}
          dataIndex="description"
          key="description"
          render={value => <CommonColumn value={value} />}
          align="center"
        />
        <Column
          title={t('table.title.value')}
          width={200}
          dataIndex="value"
          key="value"
          render={value => <CommonColumn value={value} />}
          align="center"
          className="fcmToken"
          ellipsis
        />
        <Column
          title={t('table.title.action')}
          width={200}
          dataIndex="action"
          key="action"
          render={(value, record) => <ActionsColumn record={record} />}
          align="center"
        />
      </StyledTable>
    </>
  );
};

const StyledTable = styled(Table)`
  .fcmToken > div {
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .tableGolf {
    padding: 0 1rem;
  }
`;
